export default {
    namespaced: true,
    state: {
        everyDay: null
    },
    mutations: {
        setEveryDay(state, everyDay) {
            state.everyDay = everyDay;
        }
    },
    actions: {
        setEveryDay({ commit }, everyDay) {
            commit('setEveryDay', everyDay);
        }
    },
    getters: {
        getEveryDay: state => state.everyDay
    }
}